export enum ProviderDataReviewType {
  providerSpecialtyDataReview = 'ProviderSpecialtyDataReview',
  providerFaxNumberDataReview = 'ProviderFaxNumberDataReview',
}